import { format } from "date-fns";

export const CALENDAR_CELL_ID_FORMAT = "yyyy-MM-dd";

export function getIdByDate(date: Date): string {
  return format(date, CALENDAR_CELL_ID_FORMAT);
}
